import { Controller } from "@hotwired/stimulus"

// Live confirmation for the car-delete/merge form. Compares the typed name to
// the car's EXACT name (case-insensitive, trimmed) and:
//   * shows a ✓ / ✗ hint as you type, so you know BEFORE submitting whether it
//     matches (no full-page refresh to discover a typo — Helder's feedback), and
//   * enables the submit button only on a match.
// The button is NOT disabled in HTML, so if JS fails to load the form still
// works and the server re-checks the name (case-insensitively) anyway.
export default class extends Controller {
  static targets = ["input", "submit", "matchOk", "matchBad"]
  static values = { name: String }

  connect() {
    this.check()
  }

  check() {
    const typed = this.inputTarget.value.trim().toLowerCase()
    const expected = this.nameValue.trim().toLowerCase()
    const empty = typed.length === 0
    const match = typed === expected

    if (this.hasSubmitTarget) this.submitTarget.disabled = !match
    if (this.hasMatchOkTarget) this.matchOkTarget.classList.toggle("hidden", !match)
    if (this.hasMatchBadTarget) this.matchBadTarget.classList.toggle("hidden", empty || match)
  }
}
